import { UsersApiDatasource } from '../data/datasources/users-api.datasource';
import { UsersRepositoryImpl } from '../data/repositories/users.repository.impl';

const api = new UsersApiDatasource();
const repository = new UsersRepositoryImpl(api);

export const usersContainer = { repository };
